export { default } from './cardan-car-info';